<template>
  <div class="modal" @click="onBackgroundClick">
    <div
      class="modal-mask overflow-hidden w-full h-full flex flex-col justify-center"
    >
      <slot name="full"></slot>
      <div
        v-if="$slots['default'] != null"
        class="modal-wrapper relative overflow-hidden w-full h-full box-border flex flex-col mx-auto"
        :class="{ 'lg:max-w-7/10': !noMaxWidth }"
      >
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    onBackgroundClick(event) {
      this.$emit("click", event);
    }
  },
  props: {
    noMaxWidth: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-mask {
  z-index: 100;
  padding: var(--safe-area-top) var(--safe-area-right) var(--safe-area-bottom)
    var(--safe-area-left);
}

.modal-wrapper {
  padding: 3.08rem 1.29375rem;
  z-index: 100;
}
.app-container.native-app .modal-wrapper {
  border-radius: 0;
}

@media screen and (min-width: 768px) {
  .modal-wrapper {
    padding: 2.752rem 5.28rem;
  }
}

@media (min-width: 1024px) {
  .modal-wrapper {
    padding: 0;
  }
}
</style>
